<template>
  <div class="solution-detail">
    <div class="deve-title">
      <div class="content-title">{{detailTitle}}</div>
    </div>
    <div class="solution-close" @click="$emit('close')"></div>
    <div v-html="docText" class="solutions scrollbar"></div>
  </div>
</template>

<script >
import { getSolutionDetail } from "@/api";
export default {
  components: {},
  data() {
    return {
      docText: "",
      detailTitle: ""
    };
  },
  props: {
    contentTitle: {
      type: String,
      default: ""
    },
    solutionId: {
      type: String,
      default: ""
    },
  },
  methods: {
    //展示解决方案详情
    goSolution(solutionId) {
      let params = {
        params: {
          docId: solutionId
        }
      };
      getSolutionDetail(params).then(res => {
        this.docText = res.result.data.docText;
      });
    }
  },
  created() {
    this.goSolution(this.solutionId);
    this.detailTitle = this.contentTitle;
  }
};
</script>

<style lang="less" scope>
.solution-detail {
  position: relative;
  margin:auto;
  width: 1200px;
  padding-bottom: 10px;
  background-color: #fff;
}

.deve-title {
  position: relative;
  width: 100%;
  color: #666666;
  font-size: 21px;
  text-align: center;
}
.content-title {
  float: left;
  width: 100%;
  padding: 15px 0;
  background-color: rgba(236, 236, 236, 0.5);
}

 .solution-close {
    position: absolute;
    right: 14px;
    top: 14px;
    width: 30px;
    height: 24px;
  }

  .solution-close::before,
  .solution-close::after {
    position: absolute;
    content: " ";
    background-color: #999;
    left: 20px;
    width: 2px;
    height: 25px;
  }

  .solution-close::before {
    transform: rotate(45deg);
  }

  .solution-close::after {
    transform: rotate(-45deg);
  }

  .solution-close:hover:before,
  .solution-close:hover:after{
    background-color: #5485E8;
  }
.solutions {
  height: 700px;
  overflow: auto;
  padding: 20px;
}

/* IE 浏览器 */
.scrollbar {
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #ffffff;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: rgba(236, 236, 236, 0.9);
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #ffffff;
  /*滚动条阴影*/
  scrollbar-shadow-color: #fff;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #ffffff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #fff;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #fff;
  /*滚动条基准颜色*/
  scrollbar-base-color: #fff;
}
/* chrome & safari 浏览器 */
/*滚动条整体部分,必须要设置*/
.scrollbar::-webkit-scrollbar {
  width: 8px;
  // height: 537px;
  background-color: #fff;
}
/*滚动条的轨道*/
.scrollbar::-webkit-scrollbar-track {
  background-color: #fff;
}
/*滚动条的滑块按钮*/
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: #999999;
  box-shadow: inset 0 0 5px #fff;
}
/*滚动条的上下两端的按钮*/
.scrollbar::-webkit-scrollbar-button {
  height: 0;
  background-color: #0099ff;
}
</style>


// WEBPACK FOOTER //
// src/views/solution-detail.vue